/* globals elkitorg_config */

import { node_observable_component } from 'common/util/ComponentDecorator';
import CurrencyUtil from "common/util/CurrencyUtil";
import LinkUtil from 'common/util/LinkUtil';

@node_observable_component
export default class CartSummary {
	static classname = 'cart-summary';

	constructor($summary) {
		this.$summary = $summary;
		this.initEventListeners();
		this.currency_info = elkitorg_config.currency_info[elkitorg_config.currency];
	}

	initEventListeners = () => {

		this.$summary.on('setSubtotal:parent', (e, args) => {
			this.setSubtotal(args.val);
		});

		this.$summary.on('setDiscount:parent', (e, args) => {
			this.setDiscount(args.val);
		});

		this.$summary.on('setTotal:parent', (e, args) => {
			this.setTotal(args.val);
		});

		this.$summary.on('setAffiliateDiscount:parent', (e, args) => {
			this.setAffiliateDiscount(args.val);
		});

		this.$summary.on('setAddAffiliateBonus:parent', (e, args) => {
			this.setAddAffiliateBonus(args.val, args.total);
		});

		this.$summary.on('click', '.c-cart-summary__affiliate-trigger', () => {
			this.handleAffiliate();
		})
	};

	isUseAffiliate = () => {
		return this.$summary.data('use_affiliate');
	};

	setTotal = (total) => {
		this.$summary.find('.cart-summary__total')
			.html(CurrencyUtil.format(total, this.currency_info, false));
	};

	setDiscount = (discount) => {
		this.$summary.find('.cart-summary__discount-wrap').find('.row-value').trigger('set_value:parent', {
			val: CurrencyUtil.format(discount, this.currency_info, false)
		});
		this.$summary.toggleClass('cart-summary_has-discount', (discount > 0));

	};

	setAffiliateDiscount = (discount) => {
		this.$summary.find('.cart-summary__affiliate-discount-wrap').find('.row-value').trigger('set_value:parent', {
			val: CurrencyUtil.format(discount, this.currency_info, false)
		});
		this.$summary.toggleClass('cart-summary_has-affiliate-discount', (discount > 0));
	};

	setAddAffiliateBonus = (add_affiliate_bonus, total) => {
		const percent = Math.round(add_affiliate_bonus / total * 100);
		this.$summary.find('.bonus-block__percent').text(`${percent}%`);
		this.$summary.find('.bonus-block__value').text(add_affiliate_bonus);
	};

	handleAffiliate = () => {
		const useAffiliateValue = parseInt(this.isUseAffiliate());
		console.log(useAffiliateValue);
		let useAffiliate = 0;

		if (isNaN(useAffiliateValue)) {
			useAffiliate = 1;
		}

		const url = LinkUtil.create( elkitorg_config.cart_url || '').toString();

		$.ajax({
			url: url,
			method: "post",
			data: {
				use_affiliate: useAffiliate
			}
		}).done((response) => {
			const $new_summary_container = $(response).find('.cart-summary');
			$('.cart-summary').replaceWith($new_summary_container);

			Update($new_summary_container);
		}).fail(function() {
			alert( "error" );
		}).always(function() {
		});
	};

	setSubtotal = () => {
		const $summary = this.$summary;
		$.get(window.location.href, function(response) {
			var $html = $(response);
			var $new_subtotal_summary_container = $html.find('.cart-summary__sub-total_sub-total');

			$summary.find('.cart-summary__sub-total_sub-total').html($new_subtotal_summary_container.html());
		})
	};

	refresh = () => {
		$.ajax({
			url: ''
		}).then((response) => {
			var $new_summary = $(response).find('.cart-summary');
			this.$summary.replaceWith($new_summary);

			Update($new_summary.parent());
		});
	}

};
